import Image from "next/image";

export default function Icons({
  icon,
  alt = "Icons for section",
  width = 30,
  height = 30,
}: {
  icon: string;
  alt?: string;
  width?: number;
  height?: number;
}) {
  return (
    <Image alt={alt} width={width} height={height} quality={100} src={icon} />
  );
}
